module.exports = __webpack_public_path__ + "static/media/office1.c1870d44.jpg";